module.exports = __webpack_public_path__ + "static/media/clublea_logo_small.8e298c60.svg";